export default __webpack_public_path__ + "static/media/belarus.911ca7a3.svg";